<template>
  <div class="animated fadeIn pt3 pb4 mb2">
    <div class="clearfix gibson px2 mb2">
      <div class="col-12 px2">
        <div class="clearfix border muted-border p2 mb2 shadow" v-if="showMobile">
          <div class="col-12 px2"> 
            <p class="h4 semi-bold line-height-2 my3 gibson darkblue">Faktura</p>
            <div class="flex justify-start items-center">
              <b-form>
                <b-form-checkbox id="checkbox1" v-model="status" value=1 unchecked-value=0 @change="Reload" checked-value=1></b-form-checkbox>
              </b-form>
              <p class="h6 darkblue gibson line-height-1">Vis beløb inkl. moms</p>
            </div>
          </div>
          <b-card no-body class="border-0 pt-4">
            <b-tabs card>
              <b-tab title="Abonnementsfaktura" active v-if="monthlyp === '0'">
                <balancetable :items="itemsfi"></balancetable>
              </b-tab>
              <b-tab title="SMS-Partner" v-if="monthlyp === '1'">
                <balancetable :items="itemsfi"></balancetable>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
        <div class="clearfix p2 mb2 ml4" v-if="!showMobile && !showXXL">
          <div class="col-12 px2"> 
            <p class="h4 semi-bold line-height-2 my3 gibson darkblue">Faktura</p>
            <div class="flex justify-start items-center">
              <b-form>
                <b-form-checkbox id="checkbox1" v-model="status" value=1 unchecked-value=0 @change="Reload" checked-value=1></b-form-checkbox>
              </b-form>
              <p class="h6 darkblue gibson line-height-1">Vis beløb inkl. moms</p>
            </div>
          </div>
          <b-card no-body class="border-0 pt-4">
            <b-tabs card>
              <b-tab title="Abonnementsfaktura" active v-if="monthlyp === '0'">
                <balancetable :items="itemsfi"></balancetable>
              </b-tab>
              <b-tab title="SMS-Partner" v-if="monthlyp === '1'">
                <balancetable :items="itemsfi"></balancetable>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
        <div class="clearfix p2 mb2 ml4" v-if="showXXL">
          <div class="col-6 px2"> 
            <p class="h4 semi-bold line-height-2 my3 gibson darkblue">Faktura</p>
            <div class="flex justify-start items-center">
              <b-form>
                <b-form-checkbox id="checkbox1" v-model="status" value=1 unchecked-value=0 @change="Reload" checked-value=1></b-form-checkbox>
              </b-form>
              <p class="h6 darkblue gibson line-height-1">Vis beløb inkl. moms</p>
            </div>
          </div>
          <div class="col-9 px2">
            <b-card no-body class="border-0 pt-4">
              <b-tabs card>
                <b-tab title="Abonnementsfaktura" active v-if="monthlyp === '0'">
                  <balancetable :items="itemsfi"></balancetable>
                </b-tab>
                <b-tab title="SMS-Partner" v-if="monthlyp === '1'">
                  <balancetable :items="itemsfi"></balancetable>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <div>
      <kreditkort></kreditkort>
    </div>
  </div>
</template>
<script>
import balancetable from './BalanceTable'
import balancetableOther from './BalanceTableOther'
import textcreditcard from './textCreditcard'
import Kreditkort from './EditCreditCard'
export default {
  components: {
    Kreditkort,
    balancetable,
    balancetableOther,
    textcreditcard
  },
  data () {
    return {
      status: 0,
      name: '',
      monthlyp: '',
      items: [],
      itemsfi: []
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1000) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
    this.Reload()
  },
  methods: {
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'balance_partner', salesPerson: this.salesPerson, typeMeeting: '1', vat: this.status}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res.array
            this.itemsfi = res.arrayinvoice
            this.monthlyp = res.monthlyp
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>
<style>
.modal-footer,
.modal-header {
  border-bottom: 0!important;
  border-top: 0!important;
}
.nav-tabs .nav-link.active,
.tab-content {
  border: 0;
}
.custom-control {
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// Balance.vue?1087ab24